import React,{useState,useContext} from 'react'
import {Button,Alert} from 'react-bootstrap'
import {IconContext} from 'react-icons'
import {IoArrowBack} from 'react-icons/io5'
import Loading from '../../../components/Loading/index.js'
import EditTemplate1 from './EditTemplate1.js'
import EditTemplate2 from './EditTemplate2.js'
import AuthContext from '../../../context/AuthContext.js'
import PrefixContext from '../../../context/PrefixContext.js'
import axios from 'axios'
import { useParams } from 'react-router';


function Index(props) {
    const { id } = useParams();
    const AuthContextData = useContext(AuthContext);
    const PrefixContextData = useContext(PrefixContext);
    const defaultValidation = {
        validationStatus: null,
        validationStatusClass: null,
        validationStatusMessage: null,
        validationStatusLocation: null
    }
    const [validation,setValidation] = useState(defaultValidation);
    const SavedStructure = () =>{
        if(validation.validationStatus === 'Loading') return;
        setValidation({
            validationStatus: 'Loading',
            validationStatusClass: 'warning',
            validationStatusMessage: 'Please wait updating....',
            validationStatusLocation: null
        });
        axios.post(PrefixContextData.prefixUrl + 'data/resume/'+id+'/editOrder', props.customOrder)
            .then(response => {
                if(response.status === 200){
                    setValidation({
                        validationStatus: true,
                        validationStatusClass:'success',
                        validationStatusMessage: response.data.successMessage,
                        validationStatusLocation: 'DEFAULT'
                    });
                    if(response.data.successMessageDetails !== undefined && response.data.successMessageDetails.savedDataset !== undefined && response.data.successMessageDetails.savedDataset !== null)
                    {
                        props.refreshData(response.data.successMessageDetails.savedDataset)
                    }
                }
            })
            .catch(error => {
                if(error.response !== undefined && error.response.data !== undefined){
                    if(error.response.status === 401){
                        AuthContextData.logout()
                    }
                    else{
                        setValidation({
                            validationStatus: true,
                            validationStatusClass:'danger',
                            validationStatusMessage: error.response.data.errorMessage,
                            validationStatusLocation: 'DEFAULT'
                        });
                    }
                }
                else{
                    setValidation({
                        validationStatus: true,
                        validationStatusClass:'danger',
                        validationStatusMessage: error.message,
                        validationStatusLocation: 'DEFAULT'
                    });
                }
            });
    }

    const checkIfThisLocation = (location,checkComponent) =>{
        let result = false;
        if(props.customOrder === undefined || props.customOrder === null || typeof(props.customOrder) !== 'object' || props.customOrder[location] === undefined || Array.isArray(props.customOrder[location]) === false) return result;
            if(props.customOrder[location].includes(checkComponent)) result=true;
        return result;
    }

    const checkIfComponentExists = (checkComponent) =>{
        let result = false;
        if(props.customOrder === undefined || props.customOrder === null || typeof(props.customOrder) !== 'object') return result;
        for (const [,value] of Object.entries(props.customOrder)) {
            if(value.includes(checkComponent)) result=true;
        }
        return result;
    }

    const components = ['about','profile','education','experience','projects','cocurricular','skills','social','certification','languages','interests']


    return (
        <>
            <h5 className="py-3">Edit Resume Structure</h5>
            {(validation.validationStatus !== null && validation.validationStatus !== undefined)  && <div className="text-center">
                <Alert className="d-inline-block" variant={validation.validationStatusClass}>&nbsp;&nbsp;{validation.validationStatusMessage}</Alert>
            </div>}
            <div className="modal-container">
                <div style={{overflowX:'auto'}} className="zoomout">
                    {
                    (props.customOrder !== undefined && props.customOrder !== null) ? <>
                        {props.templateIdentity === 'TemplateOne' && <EditTemplate1  refreshCustomOrderData={props.refreshCustomOrderData} components={components} checkIfComponentExists={checkIfComponentExists} data={props.customOrder} checkIfThisLocation={checkIfThisLocation}/>}
                        {props.templateIdentity === 'TemplateTwo' && <EditTemplate2  refreshCustomOrderData={props.refreshCustomOrderData} components={components} checkIfComponentExists={checkIfComponentExists} data={props.customOrder} checkIfThisLocation={checkIfThisLocation}/>}
                        </>:
                        <div className="w-50 mx-auto">
                            <Loading type="withImage" label="Loading"/>
                        </div>
                    }
                </div>
            </div>
            <div className="d-flex p-3 justify-content-between">
                <Button variant='white' className="border border-black" onClick={props.goBack}>
                    <div className="d-flex align-items-center">
                        <IconContext.Provider value={{color:'#6c757d'}}>
                            <IoArrowBack/> &nbsp;
                        </IconContext.Provider>
                        <p className="text-secondary mb-0">Go Back</p>
                    </div>
                </Button>
                {<Button className="px-3 py-2" onClick={(e)=>{SavedStructure(e)}}>
                    <div className="d-flex align-items-center">
                        <p className="mb-0">Save</p>
                    </div>
                </Button>}
            </div>
        </>
    )
}

export default Index
